import { useParams } from '@suntex.core/nav'
import { TeamId } from '@suntex.fim/api-client'
import { FocusEditor, TeamProvider } from '@suntex.fim/team'

function FocusMode() {
  const teamId = useParams().teamId as TeamId | undefined

  return (
    <TeamProvider teamId={teamId}>
      <FocusEditor
        renderUserLink={({ userId }) => (
          <span className="user-id-col">{userId}</span>
        )}
      />
    </TeamProvider>
  )
}

export default FocusMode
